/* AllianceTech V3 — theme.js */
(function () {
  'use strict';

  /* ── Toast ─────────────────────────────────────────────── */
  function showToast(msg, duration) {
    duration = duration || 2400;
    var el = document.getElementById('at-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'at-toast';
      el.className = 'at-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.classList.remove('is-visible'); }, duration);
  }

  /* ── Cart API ───────────────────────────────────────────── */
  var AT = window.AT = window.AT || {};
  var i18n = (window.AT_SETTINGS && window.AT_SETTINGS.i18n) || {};
  var cartType        = (window.AT_SETTINGS && window.AT_SETTINGS.cartType)        || 'both';
  var cartMobileStyle = (window.AT_SETTINGS && window.AT_SETTINGS.cartMobileStyle) || 'drawer';

  function shouldUseDrawer() {
    if (cartType === 'page') return false;
    if (window.innerWidth < 1024 && cartMobileStyle === 'page') return false;
    return true;
  }

  AT.cart = {
    fetch: function () {
      return fetch(atRoot() + 'cart.js').then(function (r) { return r.json(); });
    },
    add: function (variantId, qty, properties) {
      return fetch(atRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1, properties: properties || {} }),
      }).then(function (r) { return r.json(); });
    },
    update: function (line, qty) {
      return fetch(atRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: qty }),
      }).then(function (r) { return r.json(); });
    },

    /* Code promo applique sur le panier, sans quitter la page.
       POST /cart/update.js {discount} remplace le code courant et renvoie le
       panier avec discount_codes [{code, applicable}] : applicable=false
       signifie que Shopify a refuse le code (inconnu, expire, conditions non
       remplies). Chaine vide = retirer le code. */
    setDiscount: function (code) {
      return fetch(atRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ discount: code || '' }),
      }).then(function (r) { return r.json(); });
    },

    /* C — Drawer avec animation CSS (is-open / remove is-open) */
    openDrawer: function () {
      var d = document.getElementById('cart-drawer');
      if (!d) return;
      d.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    },
    closeDrawer: function () {
      var d = document.getElementById('cart-drawer');
      if (!d) return;
      d.classList.remove('is-open');
      setTimeout(function () { document.documentElement.style.overflow = ''; }, 320);
    },

    updateCount: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    },
  };

  /* ── Add to cart buttons ────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId || btn.closest('form[data-product-form]')?.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = '…';
    AT.cart.add(variantId, 1).then(function (item) {
      btn.disabled = false;
      btn.textContent = btn.dataset.labelDefault || (i18n.addToCart || 'Ajouter');
      showToast('✓ ' + item.title + ' ' + (i18n.added || 'ajouté'));
      AT.cart.fetch().then(function (cart) {
        AT.cart.updateCount(cart.item_count);
        if (shouldUseDrawer()) {
          AT.cart.renderDrawer(cart);
          AT.cart.openDrawer();
        } else {
          window.location.href = atRoot() + 'cart';
        }
      });
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = btn.dataset.labelDefault || (i18n.addToCart || 'Ajouter');
    });
  });

  /* ── Cart drawer render ─────────────────────────────────── */
  AT.cart.renderDrawer = function (cart) {
    var panel = document.querySelector('#cart-drawer .at-drawer__panel');
    if (!panel) return;

    /* D — Seuil AT_SETTINGS (Liquid), converti dans la devise d'affichage */
    var subtotalCents = cart.total_price;
    var thresholdCents = atThresholdCents();
    var remainingCents = Math.max(0, thresholdCents - subtotalCents);
    var progressPct = Math.min(100, (subtotalCents / thresholdCents) * 100);
    var subtotalFormatted = fmtMoney(subtotalCents);

    /* Header */
    var html = '<div style="padding:14px 18px;border-bottom:1px solid var(--at-line-strong);display:flex;justify-content:space-between;align-items:center;">'
      + '<span class="at-display" style="font-size:26px;">' + (i18n.cartTitle || 'PANIER') + ' · ' + cart.item_count + '</span>'
      + '<button type="button" data-cart-close aria-label="' + (i18n.close || 'Fermer') + '" class="at-header__icon-btn">'
      + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>'
      + '</button></div>';

    /* D — Barre livraison : afficher dans les 2 états */
    html += '<div style="padding:12px 18px;border-bottom:1px solid var(--at-line);background:var(--at-surface);">';
    if (remainingCents > 0) {
      html += '<div class="at-mono" style="font-size:10px;color:var(--at-accent);letter-spacing:0.12em;margin-bottom:6px;text-transform:uppercase;">'
        + '+ ' + fmtMoney(remainingCents) + ' → ' + (i18n.freeShipping || 'LIVRAISON OFFERTE') + '</div>'
        + '<div class="at-free-ship-bar"><div class="at-free-ship-bar__fill" style="width:' + progressPct.toFixed(1) + '%"></div></div>';
    } else {
      html += '<div class="at-mono" style="font-size:10px;color:var(--at-success,#16a34a);letter-spacing:0.12em;text-transform:uppercase;">'
        + (i18n.freeShippingAcquired || '✓ LIVRAISON OFFERTE ACQUISE') + '</div>'
        + '<div class="at-free-ship-bar"><div class="at-free-ship-bar__fill" style="width:100%;background:var(--at-success,#16a34a);"></div></div>';
    }
    html += '</div>';

    /* Items */
    html += '<div style="flex:1;overflow-y:auto;padding:0 18px;">';
    if (cart.items.length === 0) {
      html += '<p style="text-align:center;color:var(--at-muted);padding:48px 0;">' + (i18n.empty || 'Votre panier est vide.') + '</p>';
    } else {
      cart.items.forEach(function (item, idx) {
        var linePrice = fmtMoney(item.line_price);
        var hasDiscount = item.original_line_price > item.line_price;
        html += '<div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid var(--at-line);">'
          + '<a href="' + item.url + '" style="flex-shrink:0;width:64px;height:64px;border-radius:var(--at-radius);overflow:hidden;border:1px solid var(--at-line);background:var(--at-surface-alt);">'
          + '<img src="' + (item.image || '') + '" alt="' + item.product_title + '" style="width:100%;height:100%;object-fit:cover;" loading="lazy">'
          + '</a>'
          + '<div style="flex:1;min-width:0;">'
          + '<div class="at-mono" style="font-size:9px;color:var(--at-accent);letter-spacing:0.14em;text-transform:uppercase;margin-bottom:3px;">' + (item.vendor || '') + '</div>'
          + '<a href="' + item.url + '" style="font-size:13px;font-weight:500;line-height:1.3;color:var(--at-text);text-decoration:none;display:block;margin-bottom:8px;">'
          + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '')
          + '</a>'
          + '<div style="display:flex;justify-content:space-between;align-items:center;">'
          + '<div class="at-qty" data-line="' + (idx + 1) + '">'
          + '<button class="at-qty__btn" data-qty-dec aria-label="' + (i18n.decrease || 'Décrémenter') + '">−</button>'
          + '<span class="at-qty__val">' + item.quantity + '</span>'
          + '<button class="at-qty__btn" data-qty-inc aria-label="' + (i18n.increase || 'Incrémenter') + '">+</button>'
          + '</div>'
          + '<div style="text-align:right;">'
          + (hasDiscount ? '<div style="font-size:10px;color:var(--at-muted);text-decoration:line-through;">' + fmtMoney(item.original_line_price) + '</div>' : '')
          + '<span class="at-display" style="font-size:18px;' + (hasDiscount ? 'color:var(--at-hot);' : '') + '">' + linePrice + '</span>'
          + '</div>'
          + '</div></div></div>';
      });
    }
    html += '</div>';

    /* Footer : sous-total + code promo + checkout */
    var savingsHtml = '';
    if (cart.total_discount && cart.total_discount > 0) {
      savingsHtml = '<div class="at-mono" style="font-size:10px;color:var(--at-success,#16a34a);letter-spacing:0.10em;margin-bottom:8px;">'
        + (i18n.youSave || 'Vous économisez') + ' ' + fmtMoney(cart.total_discount) + '</div>';
    }

    html += '<div style="padding:16px 18px;border-top:1px solid var(--at-line-strong);">'
      + savingsHtml
      + '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:14px;">'
      + '<span class="at-mono" style="font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--at-muted);">' + (i18n.subtotal || 'Sous-total') + '</span>'
      + '<span class="at-display" style="font-size:32px;color:var(--at-accent);">' + subtotalFormatted + '</span>'
      + '</div>'
      /* B · Code promo : applique sur le panier en AJAX, pas de saut au checkout */
      + atDiscountHtml(cart, true)
      + '<a href="' + atRoot() + 'checkout" class="at-btn at-btn--primary at-btn--block" style="display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:0;">'
      + (i18n.checkout || 'Commander') + ' →</a>'
      + '</div>';

    panel.innerHTML = html;

    /* Qty stepper handlers */
    panel.querySelectorAll('[data-qty-dec],[data-qty-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepper = btn.closest('[data-line]');
        var line = parseInt(stepper.dataset.line, 10);
        var valEl = stepper.querySelector('.at-qty__val');
        var current = parseInt(valEl.textContent, 10);
        var next = btn.hasAttribute('data-qty-dec') ? Math.max(0, current - 1) : current + 1;
        AT.cart.update(line, next).then(function (cart) {
          AT.cart.updateCount(cart.item_count);
          AT.cart.renderDrawer(cart);
        });
      });
    });

    panel.querySelector('[data-cart-close]')?.addEventListener('click', AT.cart.closeDrawer);
  };

  /* ── Helpers ────────────────────────────────────────────── */
  /* Racine localisee (/fr, /pl…) : les URLs ecrites en dur perdent la locale. */
  function atRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }
  /* Le code promo vient d'un champ libre : il est reinjecte en innerHTML. */
  function atEsc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* GET /cart.js renvoie l'application de remise a plat, POST /cart/update.js
     et /cart/change.js l'enveloppent dans {amount, discount_application}.
     Sans ce lissage, title et total_allocated_amount sortent undefined apres
     un changement de quantite ou de code. */
  function atCartDiscounts(cart) {
    return (cart.cart_level_discount_applications || []).map(function (d) {
      return d.discount_application || d;
    });
  }
  /* Bloc code promo partage par le drawer et la page panier : code applique
     (+ montant + retrait), champ de saisie, zone de message. */
  function atDiscountHtml(cart, compact) {
    var t = (window.AT_SETTINGS && window.AT_SETTINGS.i18n) || {};
    var apps = atCartDiscounts(cart);
    var gap  = compact ? '6px' : '8px';
    var html = '';

    (cart.discount_codes || []).forEach(function (d) {
      if (!d.applicable) return;
      var app = apps.filter(function (a) {
        return String(a.title).toLowerCase() === String(d.code).toLowerCase();
      })[0];
      html += '<div class="at-mono" style="display:flex;align-items:center;justify-content:space-between;gap:8px;font-size:11px;color:var(--at-accent);letter-spacing:0.10em;margin-bottom:8px;">'
        + '<span>✓ ' + atEsc(d.code) + (app ? ' · −' + fmtMoney(app.total_allocated_amount) : '') + '</span>'
        + '<button type="button" data-discount-remove style="background:none;border:0;padding:0;font:inherit;color:var(--at-muted);text-decoration:underline;text-transform:uppercase;cursor:pointer;">'
        + atEsc(t.remove || 'Retirer') + '</button>'
        + '</div>';
    });

    html += '<div data-discount-form style="display:flex;gap:' + gap + ';margin-bottom:6px;">'
      + '<input type="text" data-discount-input placeholder="' + atEsc(t.discountPlaceholder || 'Code promo') + '" class="at-input" autocomplete="off" spellcheck="false" style="flex:1;min-width:0;padding:9px 12px;font-size:12px;border:1px solid var(--at-line-strong);border-radius:var(--at-radius,6px);background:var(--at-surface);color:var(--at-text);font-family:inherit;">'
      + '<button type="button" data-discount-submit style="padding:9px 14px;background:transparent;border:1px solid var(--at-line-strong);border-radius:var(--at-radius,6px);font-family:var(--at-font-mono,monospace);font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:var(--at-text);cursor:pointer;white-space:nowrap;">OK</button>'
      + '</div>'
      + '<div data-discount-msg class="at-mono" style="font-size:10px;letter-spacing:0.08em;margin-bottom:12px;"></div>';

    return html;
  }
  function atCurrency() {
    var c = window.Shopify && window.Shopify.currency;
    return (c && c.active) || 'EUR';
  }
  function atRate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c && parseFloat(c.rate);
    return (r && isFinite(r) && r > 0) ? r : 1;
  }
  /* La boutique est multi-devises (Shopify Markets) : /cart.js renvoie des
     montants dans la devise d'affichage du visiteur, pas en euros. */
  function fmtMoney(cents) {
    var cur = atCurrency();
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: cur
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + (cur === 'EUR' ? ' €' : ' ' + cur);
    }
  }
  /* Seuil de franco : defini en EUR cote Shopify (la condition de tarif est
     evaluee en devise boutique), converti ici dans la devise d'affichage. */
  function atThresholdCents() {
    var st = window.AT_SETTINGS || {};
    var eur = st.freeShippingThresholdEur || st.freeShippingThreshold || 29;
    return Math.round(eur * atRate() * 100);
  }
  /* Arrondi vers le HAUT : on annonce toujours un montant >= au seuil reel,
     jamais l'inverse, pour que la promesse soit tenue au checkout. */
  function atNiceUp(v) {
    return v >= 100 ? Math.ceil(v / 10) * 10 : Math.ceil(v);
  }
  /* Textes statiques marques [data-at-ship] (bandeau PDP, reassurance,
     barre d'annonce) : remplace le montant EUR par son equivalent local. */
  function atLocalizeShipText() {
    var st = window.AT_SETTINGS || {};
    var rate = atRate();
    if (rate === 1 || !st.freeShippingDisplay || !st.freeShippingThresholdEur) return;
    var local = atNiceUp(st.freeShippingThresholdEur * rate * 1.02);
    var out;
    try {
      out = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: atCurrency(), maximumFractionDigits: 0
      }).format(local);
    } catch (e) { out = local + ' ' + atCurrency(); }
    var nodes = document.querySelectorAll('[data-at-ship]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent.indexOf(st.freeShippingDisplay) !== -1) {
        nodes[i].textContent = nodes[i].textContent.replace(st.freeShippingDisplay, out);
      }
    }
  }
  /* Rendu unique de la barre de progression du franco, partage entre le
     chargement de page et les mises a jour AJAX. */
  function atUpdateShipBar(totalCents) {
    var thresholdCents = atThresholdCents();
    var remaining = Math.max(0, thresholdCents - totalCents);
    var pct = Math.min(100, (totalCents / thresholdCents) * 100);
    var barLabel = document.getElementById('cart-ship-label');
    var barFill  = document.getElementById('cart-ship-fill');
    var i18n = (window.AT_SETTINGS && window.AT_SETTINGS.i18n) || {};
    if (barLabel) {
      barLabel.textContent = remaining > 0
        ? '+ ' + fmtMoney(remaining) + ' → ' + (i18n.freeShipping || 'LIVRAISON OFFERTE')
        : (i18n.freeShippingAcquired || '✓ LIVRAISON OFFERTE ACQUISE');
      barLabel.style.color = remaining > 0 ? 'var(--at-accent)' : 'var(--at-success,#16a34a)';
    }
    if (barFill) {
      barFill.style.width = pct.toFixed(1) + '%';
      barFill.style.background = remaining > 0 ? 'var(--at-accent)' : 'var(--at-success,#16a34a)';
    }
  }

  /* ── Cart page : mise à jour AJAX de la liste items + summary ─ */
  AT.cart.updateCartPage = function (cart) {
    /* Compteur dans le h1 */
    var countEl = document.getElementById('cart-item-count');
    if (countEl) countEl.textContent = cart.item_count + ' ARTICLE' + (cart.item_count !== 1 ? 'S' : '');

    /* Barre livraison (seuil converti dans la devise d'affichage) */
    atUpdateShipBar(cart.total_price);
    var remaining = Math.max(0, atThresholdCents() - cart.total_price);

    /* Summary : sous-total, livraison, total, économies */
    var subtotalEl = document.getElementById('cart-subtotal');
    var totalEl    = document.getElementById('cart-total');
    var stickyEl   = document.getElementById('cart-sticky-total');
    var shipEl     = document.getElementById('cart-shipping-val');
    var savingsEl  = document.getElementById('cart-savings');
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.items_subtotal_price);
    if (totalEl)    totalEl.textContent    = fmtMoney(cart.total_price);
    if (stickyEl)   stickyEl.textContent   = fmtMoney(cart.total_price);
    if (shipEl) {
      if (remaining > 0) {
        shipEl.innerHTML = (i18n.shippingCalculated || 'Calculée au checkout');
      } else {
        shipEl.innerHTML = '<strong style="color:var(--at-accent);">' + (i18n.free || 'Offerte') + '</strong>';
      }
    }
    if (savingsEl) {
      if (cart.total_discount > 0) {
        savingsEl.textContent = (i18n.youSave || 'Vous économisez') + ' ' + fmtMoney(cart.total_discount);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }

    /* Remises : bloc code promo (resume) + rappel sous la liste d'articles */
    var discountBlock = document.getElementById('cart-discount-block');
    if (discountBlock) discountBlock.innerHTML = atDiscountHtml(cart, false);

    var discountLines = document.getElementById('cart-discount-lines');
    if (discountLines) {
      var apps = atCartDiscounts(cart);
      discountLines.innerHTML = apps.map(function (d) {
        return '<div class="at-mono" style="font-size:11px;color:var(--at-accent);letter-spacing:0.10em;">'
          + '✓ ' + atEsc(d.title) + ' · −' + fmtMoney(d.total_allocated_amount) + '</div>';
      }).join('');
      discountLines.style.display = apps.length ? '' : 'none';
    }

    /* Re-render de la liste des items */
    var itemsContainer = document.getElementById('cart-items-list');
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      /* Recharger la page si panier vide — plus simple que de gérer l'état vide en JS */
      window.location.reload();
      return;
    }

    var itemsHtml = '';
    cart.items.forEach(function (item, idx) {
      var hasDiscount = item.original_line_price > item.final_line_price;
      var variantLine = '';
      if (item.options_with_values && item.options_with_values.length > 0 && !(item.options_with_values.length === 1 && item.options_with_values[0].value === 'Default Title')) {
        variantLine = '<div class="at-mono" style="font-size:10px;color:var(--at-muted);letter-spacing:0.10em;margin-top:4px;">'
          + item.options_with_values.map(function(o){ return o.name + ': ' + o.value; }).join(' · ')
          + '</div>';
      }
      itemsHtml += '<li class="at-cart__item" style="display:grid;grid-template-columns:88px 1fr auto;gap:16px;padding:20px 0;border-bottom:1px solid var(--at-line);">'
        + '<a href="' + item.url + '" style="width:88px;height:88px;background:var(--at-surface-alt);border:1px solid var(--at-line);border-radius:var(--at-radius);overflow:hidden;display:block;">'
        + '<img src="' + (item.image || '') + '" alt="' + item.product_title + '" style="width:100%;height:100%;object-fit:cover;" loading="lazy">'
        + '</a>'
        + '<div style="min-width:0;">'
        + '<div class="at-mono" style="font-size:9px;letter-spacing:0.14em;text-transform:uppercase;color:var(--at-accent);margin-bottom:4px;">' + (item.vendor || '') + '</div>'
        + '<a href="' + item.url + '" style="font-size:14px;font-weight:500;color:var(--at-text);text-decoration:none;line-height:1.3;">' + item.product_title + '</a>'
        + variantLine
        + '<div style="display:flex;align-items:center;gap:12px;margin-top:12px;">'
        + '<div class="at-qty" data-line="' + (idx + 1) + '">'
        + '<button type="button" class="at-qty__btn" data-cart-qty data-line="' + (idx + 1) + '" data-action="dec" aria-label="' + (i18n.decrease || 'Décrémenter') + '">−</button>'
        + '<span class="at-qty__val">' + item.quantity + '</span>'
        + '<button type="button" class="at-qty__btn" data-cart-qty data-line="' + (idx + 1) + '" data-action="inc" aria-label="' + (i18n.increase || 'Incrémenter') + '">+</button>'
        + '</div>'
        + '<button type="button" class="at-mono" data-cart-remove data-line="' + (idx + 1) + '" style="font-size:10px;letter-spacing:0.10em;color:var(--at-muted);background:none;border:none;cursor:pointer;text-decoration:underline;text-transform:uppercase;">'
        + (i18n.remove || 'Retirer') + '</button>'
        + '</div>'
        + '</div>'
        + '<div style="text-align:right;">'
        + '<div class="at-display" style="font-size:22px;color:var(--at-text);">' + fmtMoney(item.final_line_price) + '</div>'
        + (hasDiscount ? '<div style="font-size:11px;color:var(--at-muted);text-decoration:line-through;">' + fmtMoney(item.original_line_price) + '</div>' : '')
        + '</div>'
        + '</li>';
    });

    itemsContainer.innerHTML = itemsHtml;
  };

  /* ── Cart page : AJAX qty + remove (delegation) ─────────── */
  document.addEventListener('click', function (e) {
    var qtyBtn    = e.target.closest('[data-cart-qty]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!qtyBtn && !removeBtn) return;

    var btn  = qtyBtn || removeBtn;
    var line = parseInt(btn.dataset.line, 10);
    if (!line) return;

    var qty;
    if (removeBtn) {
      qty = 0;
    } else {
      var valEl = btn.closest('.at-qty')?.querySelector('.at-qty__val');
      var current = valEl ? parseInt(valEl.textContent, 10) : 1;
      qty = btn.dataset.action === 'dec' ? Math.max(0, current - 1) : current + 1;
    }

    btn.disabled = true;
    AT.cart.update(line, qty).then(function (cart) {
      AT.cart.updateCount(cart.item_count);
      /* Mise à jour page si on est sur /cart */
      if (document.getElementById('cart-items-list')) {
        AT.cart.updateCartPage(cart);
      }
    }).catch(function () {
      btn.disabled = false;
    });
  });

  /* ── Code promo : appliquer / retirer (drawer + page panier) ── */
  /* Re-rend les surfaces panier visibles, puis repose le message : le bloc
     promo est recree a chaque rendu, donc le message doit venir apres. */
  function atRenderAfterDiscount(cart, msg, ok) {
    AT.cart.updateCount(cart.item_count);
    var drawer   = document.getElementById('cart-drawer');
    var inDrawer = !!(drawer && drawer.classList.contains('is-open'));

    if (document.getElementById('cart-items-list')) AT.cart.updateCartPage(cart);
    if (inDrawer) AT.cart.renderDrawer(cart);

    var scope = inDrawer ? drawer : (document.getElementById('cart-discount-block') || document);
    var el = scope.querySelector('[data-discount-msg]');
    if (el) {
      el.textContent = msg || '';
      el.style.color = ok ? 'var(--at-success,#16a34a)' : 'var(--at-error,#dc2626)';
    }
  }

  function atSubmitDiscount(block) {
    if (!block) return;
    var input = block.querySelector('[data-discount-input]');
    var code  = ((input && input.value) || '').trim();
    if (!code) return;
    var btn = block.querySelector('[data-discount-submit]');
    if (btn) btn.disabled = true;

    /* Le panier Shopify ne porte qu'un code a la fois : on memorise celui en
       place pour le restaurer si le nouveau est refuse. */
    AT.cart.fetch().then(function (before) {
      var kept = (before.discount_codes || []).filter(function (d) { return d.applicable; });
      var restore = kept.length ? kept[0].code : '';

      return AT.cart.setDiscount(code).then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (d) {
          return String(d.code).toLowerCase() === code.toLowerCase();
        })[0];

        if (entry && entry.applicable) {
          atRenderAfterDiscount(cart, i18n.discountApplied || 'Code appliqué', true);
          return;
        }
        /* Refuse : on remet l'etat precedent pour ne pas trainer un code mort
           jusqu'au checkout, et on le dit au client. */
        return AT.cart.setDiscount(restore).then(function (clean) {
          atRenderAfterDiscount(clean, i18n.discountInvalid || 'Code promo invalide ou non applicable', false);
        });
      });
    }).catch(function () {
      if (btn) btn.disabled = false;
      var el = block.parentNode && block.parentNode.querySelector('[data-discount-msg]');
      if (el) {
        el.textContent = i18n.discountInvalid || 'Code promo invalide ou non applicable';
        el.style.color = 'var(--at-error,#dc2626)';
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-submit]');
    if (!btn) return;
    e.preventDefault();
    atSubmitDiscount(btn.closest('[data-discount-form]'));
  });

  /* Entree dans le champ : sur /cart l'input appartient au <form> du panier,
     sans preventDefault la page serait rechargee sans appliquer le code. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-discount-form] [data-discount-input]');
    if (!input) return;
    e.preventDefault();
    atSubmitDiscount(input.closest('[data-discount-form]'));
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-discount-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.disabled = true;
    AT.cart.setDiscount('').then(function (cart) {
      atRenderAfterDiscount(cart, '', true);
    }).catch(function () { rm.disabled = false; });
  });

  /* ── Cart drawer open trigger ───────────────────────────── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      if (!shouldUseDrawer()) return; // laisse le href="/cart" naviguer normalement
      e.preventDefault();
      AT.cart.fetch().then(function (cart) {
        AT.cart.renderDrawer(cart);
        AT.cart.openDrawer();
      });
    }
    if (e.target.closest('[data-cart-close]')) AT.cart.closeDrawer();
    var cd = document.getElementById('cart-drawer');
    if (cd && e.target === cd) AT.cart.closeDrawer();
  });

  /* ── Inject cart drawer shell ───────────────────────────── */
  (function () {
    if (document.getElementById('cart-drawer')) return;
    var el = document.createElement('div');
    el.id = 'cart-drawer';
    el.className = 'at-drawer at-drawer--right';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', i18n.cartTitle || 'Panier');
    /* C — Pas de style inline : l'animation est gérée par CSS .is-open */
    el.innerHTML = '<div class="at-drawer__panel" style="width:94%;max-width:420px;"></div>';
    document.body.appendChild(el);
  })();

  /* ── Variant picker ─────────────────────────────────────── */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form[data-product-form]');
    var hiddenInput = form && form.querySelector('[name="id"]');
    var addBtn = form && form.querySelector('[data-add-to-cart]');

    picker.querySelectorAll('.at-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        picker.querySelectorAll('.at-variant-btn').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-active');
        });
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.add('is-active');
        if (hiddenInput) hiddenInput.value = btn.dataset.variantId;
        if (addBtn) {
          var avail = btn.dataset.available !== 'false';
          addBtn.disabled = !avail;
          addBtn.textContent = avail ? (addBtn.dataset.labelDefault || (i18n.addToCart || 'Ajouter au panier')) : (i18n.outOfStock || 'Épuisé');
        }
      });
    });
  });

  /* ── Predictive search ──────────────────────────────────── */
  (function () {
    var input = document.querySelector('[data-predictive-search]');
    var results = document.querySelector('[data-search-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) { results.innerHTML = ''; results.hidden = true; return; }
            results.innerHTML = products.map(function (p) {
              return '<a href="' + p.url + '" style="display:flex;gap:10px;align-items:center;padding:10px;text-decoration:none;color:var(--at-text);border-bottom:1px solid var(--at-line);">'
                + '<img src="' + (p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/\.jpg/, '_60x60.jpg') : '') + '" width="40" height="40" style="border-radius:var(--at-radius-sm);object-fit:cover;" loading="lazy">'
                + '<div><div style="font-size:13px;font-weight:500;">' + p.title + '</div>'
                + '<div class="at-mono" style="font-size:10px;color:var(--at-muted);">' + (p.price ? fmtMoney(parseFloat(p.price)) : '') + '</div></div>'
                + '</a>';
            }).join('');
            results.hidden = false;
          });
      }, 300);
    });

    document.addEventListener('click', function (e) {
      if (!results.contains(e.target) && e.target !== input) {
        results.innerHTML = '';
        results.hidden = true;
      }
    });
  })();

  /* ── Init on DOM ready ──────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    AT.cart.fetch().then(function (cart) {
      AT.cart.updateCount(cart.item_count);
    });
    /* Devise locale : convertir les montants annonces en statique */
    atLocalizeShipText();
    /* Barre de franco de la page panier : recalculee avec le taux live */
    var shipBar = document.querySelector('[data-at-ship-bar]');
    if (shipBar) atUpdateShipBar(parseInt(shipBar.getAttribute('data-total'), 10) || 0);
  });

})();
